import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';

/**
 * Eén eigenschap als tegel (tegelweergave van het basis-paneel): een herkenbaar
 * duotone-icoon links, op regel 1 het label met rechts de actie-iconen (info,
 * omgeving-matches), daaronder de waarde.
 *
 * Slots: `[tileAction]` voor de knoppen op regel 1, de standaard-slot voor de
 * waarde en `[tileFooter]` voor inhoud over de volle tegelbreedte onder de
 * waarde (bv. een uitgeklapte matchlijst). De tegel is een grid-item: `wide`
 * laat hem beide kolommen van het tegelraster beslaan.
 */
@Component({
  selector: 'hd-property-tile',
  standalone: true,
  templateUrl: './hd-property-tile.component.html',
  styleUrl: './hd-property-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-wide]': 'wide()',
  },
})
export class HdPropertyTileComponent {
  /** Font Awesome-naam zonder prefix (bv. `compass`); getoond in de duotone-stijl. */
  readonly icon = input.required<string>();
  readonly label = input.required<string>();
  /** Volle breedte van het tegelraster (lange waarden zoals de kruisen). */
  readonly wide = input(false, { transform: booleanAttribute });
}
